import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import SideBar from "../../SideBar/SideBar";
import EmailInvite from "./EmailInvite";
import Loader from "../../Loader/Loader";
import BackButton from "../../BackButton/BackButton";
import PrivacyTermsConditions from "../../PrivacyTermsConditions/PrivacyTermsConditions";

const EmailInvitePage = () => {
  // state to make the tab active
  const [currentTab, setcurrentTab] = useState("");
  // state to toggle the loader page
  const [loading, setLoading] = useState(true);

  const path = window.location.href;
  const endPath = path.split("/")[4];

  // hooks to use the end path to set the current tab
  useEffect(() => {
    if (endPath === "email-for-invite-business") {
      setcurrentTab("email-for-invite-business");
    }
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, []);

  return (
    <>
      {loading === true ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4 shopLocalAi">
          <BackButton />
          <p className="page-maintitle">CommunityX AI</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink
                className={
                  currentTab === "email-for-invite-business"
                    ? "tabs_li activeTab"
                    : "tabs_li"
                }
              >
                Email for Invite Businesses
              </NavLink>
              <NavLink
                to={"/shop-local-ai/promote-campaign"}
                className={"tabs_li"}
              >
                Promote Campaign
              </NavLink>
            </div>

            <div className="mt-3">
              <EmailInvite />
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default EmailInvitePage;
